import React, { Component } from 'react';
import ReactGA from 'react-ga';
import $ from 'jquery';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Contact from './Components/Contact';
import Testimonials from './Components/Testimonials';
import sounds from "./shared/sounds/sounds";
import ReactNotification from 'react-notifications-component';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      foo: 'bar',
      resumeData: {},
      sound: false
    };

    ReactGA.initialize('G-BH7XNTEJ1R');
    ReactGA.pageview(window.location.pathname);
  }

  getResumeData() {
    $.ajax({
      url: '/resumeData.json',
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({ resumeData: data });
      }.bind(this),
      error: function (xhr, status, err) {
        sounds.accept.play();
        alert(err);
      }
    });
  }

  componentDidMount() {
    this.getResumeData();
  }

  playSound() {
    if (this.state.sound) {
      return;
    }

    var playedPromise = sounds.accept.play();
    if (playedPromise) {
      playedPromise.then((e) => {
        this.setState({ sound: true });
      }).catch((e) => {
        this.setState({ sound: false });
        console.log(e)
        if (e.name === 'NotAllowedError' || e.name === 'NotSupportedError') {
          console.log(e.name);
        }
      })
    }
  }

  render() {
    return (
      <div className="App" onWheel={(e) => this.playSound()} >
        <ReactNotification />
        <Header data={this.state.resumeData.main} />
        <About data={this.state.resumeData.main} />
        <Testimonials data={this.state.resumeData.testimonials} />
        <Contact data={this.state.resumeData.main} />
        <Footer data={this.state.resumeData.main} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js